document.addEventListener('DOMContentLoaded', () => {
    $('.sliding-banner-slick').slick({
        arrows: false,
        dots: true,
        // autoplay: true,
        accessibility: false,
    });

    const dots = document.querySelectorAll('.slick-dots li button')
    dots.forEach((dot,index) => {
      dot.innerText = ""
      dot.setAttribute("aria-label",`Go to ${index+1} slide`)
    })

    // const pauseButton = document.querySelector('.sliding-banner-slick-pause-button');
    // setButtonStatus(pauseButton);
    // pauseButton.addEventListener('click', () => {
    //   if ($('.sliding-banner-slick')[0].slick.paused) {
    //     $('.sliding-banner-slick')[0].slick.slickPlay();
    //     $('.sliding-banner-slick')[1].slick.slickPlay();
    //   } else {
    //     $('.sliding-banner-slick')[0].slick.slickPause();
    //     $('.sliding-banner-slick')[1].slick.slickPause();
    //   }
    //   setButtonStatus(pauseButton);
    // })

    const sliderLinks = document.querySelectorAll('.slick-slide')
    sliderLinks.forEach(link => {
      link.setAttribute('tabindex','-1')
    })
    
    function updateAriaCurrent() {
      const slides = document.querySelectorAll('.slick-slide');
      slides.forEach(function(slide) {
        slide.setAttribute('aria-current', 'false');
      });
    
      let currentSlideElement = document.querySelector('.slick-active');
      if (currentSlideElement) {
        currentSlideElement.setAttribute('aria-current', 'true');
      }
      const dots = document.querySelectorAll('.slick-dots li')
      dots.forEach(function(dot) {
        const button = dot.querySelector('button')
        if(button) {
          button.setAttribute('aria-current','false')
        }
      })
      let currentDotElement = document.querySelector('.slick-dots .slick-active')
      if(currentDotElement){
        const button = currentDotElement.querySelector('button')
        if(button){
          button.setAttribute('aria-current','true')
        }
      }
    }
    updateAriaCurrent();
    
    const observer = new MutationObserver(function(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          updateAriaCurrent();
        }
      }
    });
    
    document.querySelectorAll('.slick-slide').forEach(function(slide) {
      observer.observe(slide, { attributes: true });
    });
    
    document.querySelectorAll('.slick-dots li').forEach(function(dot) {
       observer.observe(dot, { attributes: true });
    });
})

function setButtonStatus(pauseButton) {
  if ($('.sliding-banner-slick')[0].slick.paused) {
    pauseButton.querySelector('.js-when-playing').style.display = 'none';
    pauseButton.querySelector('.js-when-paused').style.display = 'inline';
  } else {
    pauseButton.querySelector('.js-when-playing').style.display = 'inline';
    pauseButton.querySelector('.js-when-paused').style.display = 'none';
  }
}
